<template>
  <card-care-deal
    v-if="cardData.ss_type === 'care_deals'"
    :isConnected="isConnected"
    :listResFav="resApiFav"
    :card-data="cardData"
    @favorisMajComponentType ="favorisMajComponent"
    :map-url="goMapUrl(getCurrentLocation())"
    @onMapAskFlyTo="$emit('onMapAskFlyTo', cardData.locs_field_geolocalisation$latlon)"
  />
  <card-standard
    v-else
    :isConnected="isConnected"
    :listResFav="resApiFav"
    :cardData="cardData"
    :cardLink="setUrl(cardData.ss_field_node_path_alias)"
    :cardNames="cardData.tm_establishment_type_names"
    :context="context"
    :tcModeType="tcModeType"
    :isMobile="isMobile"
    v-bind="cardPropsBuilder(cardData.ss_type)"
    @favorisMajComponentType ="favorisMajComponent"
    has-appointment-bloc
    :map-url="goMapUrl(getCurrentLocation())"
    @onMapAskFlyTo="$emit('onMapAskFlyTo', cardData.locs_field_geolocalisation$latlon)"
  >
    <template v-if="cardPropsBuilder(cardData.ss_type)['has-health-institution-bloc']" #blocService="{ cardData }" >
      <CardServiceBloc  :cardData="cardData" />
    </template>
    <template v-if="cardPropsBuilder(cardData.ss_type)['has-professional-bloc']" #blocProfessional>
      <CardProfessionalBlock :cardData="cardData"/>
    </template>
  </card-standard>
</template>

<script>

import { inject, ref } from 'vue';
import CardCareDealComponent from '@/components/searchFind/cardType/CardCareDealComponent.vue';
import GeolocationHook from '@/hooks/geoLocation.hook';
import CardStandard from '@/components/searchFind/cardType/CardStandard.component.vue';
import CardServiceBloc from '@/components/searchFind/cardType/CardServiceBloc.component.vue';
import CardProfessionalBlock from '@/components/searchFind/cardType/CardProfessionalBlock.component.vue';

export default {
  name: 'CardComponent',
  emits: ['favorisMajListComponent', 'onOnMapAskFlyTo'],
  props: {
    cardData: {
      type: Object,
      default: () => ({}),
    },
    context: {
      type: String,
      default: '',
    },
    tcModeType: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'card-care-deal': CardCareDealComponent,
    CardStandard,
    CardServiceBloc,
    CardProfessionalBlock,
  },
  setup(props, { emit }) {
    const isConnected = inject('isConnected');
    const resApiFav = inject('resApiFav');
    const listCurrentFilter = inject('listCurrentFilter', {});
    const { getCurrentLocation } = GeolocationHook();
    const basePathAlias = ref(props.cardData.ss_field_node_path_alias);

    function setUrl(url) {
      let buffer = url;

      if (props.cardData.ss_type === 'professionnel_de_sante') {
        let args = `#q=${window.location.pathname.substring(1)}`;

        if (listCurrentFilter.value) {
          args += `&filters=${JSON.stringify(listCurrentFilter.value)}`;
        }

        buffer += args;
      }

      return buffer;
    }

    function goMapUrl({ lon, lat }) {
      if (!props.cardData.locs_field_geolocalisation$latlon) return '';
      const googleMapBaseUrl = 'https://www.google.com/maps/dir/';
      return `${googleMapBaseUrl + lat},${lon}/${props.cardData.locs_field_geolocalisation$latlon.split(',').reverse().join(',')}`;
    }

    function favorisMajComponent(cartId) {
      emit('favorisMajListComponent', cartId);
    }

    function cardPropsBuilder(type) {
      const cardProps = {
        service_de_sante: {
          'label-icon': 'Service de santé',
          'has-appointment-bloc': true,
          'has-pharmacy-bloc': true,
          'has-health-institution-bloc': false,
          'has-professional-bloc': false,
        },
        professionnel_de_sante: {
          'label-icon': 'Professionel de santé',
          'has-appointment-bloc': false,
          'has-pharmacy-bloc': false,
          'has-health-institution-bloc': false,
          'has-professional-bloc': true,
        },
        finess_institution: {
          'label-icon': 'Service de santé',
          'has-appointment-bloc': false,
          'has-pharmacy-bloc': false,
          'has-health-institution-bloc': false,
          'has-professional-bloc': false,
        },
        entite_geographique: {
          'label-icon': 'Service de santé',
          'has-appointment-bloc': true,
          'has-pharmacy-bloc': false,
          'has-health-institution-bloc': false,
          'has-professional-bloc': false,
        },
        health_institution: {
          'label-icon': 'Service de santé',
          'has-appointment-bloc': true,
          'has-pharmacy-bloc': false,
          'has-health-institution-bloc': true,
          'has-professional-bloc': false,
        },
      }[type];

      return cardProps;
    }
    return {
      goMapUrl,
      getCurrentLocation,
      listCurrentFilter,
      basePathAlias,
      favorisMajComponent,
      cardPropsBuilder,
      isConnected,
      resApiFav,
      setUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.card{
  width: 100%;
  &:hover{
    border-color: #00457f;
  }
  &__header{
    display: flex;
    justify-content: flex-start;
    margin-bottom: 22px;
    align-items: center;
    &__icon{
      font-size: 1.9375rem;
      color: black;
      padding-right: 16px;
      text-align: center;
    }
    &__title{
      h2{
        margin: 0 0 3px;
        font-weight: 600;
        font-size: 1rem;
        padding: 0;
        text-align: left;
        position: relative;
        color:#00457f;
        a{
          color: inherit;
          text-decoration: underline;
        }
      }
    }
    &__subtitle{
      font-weight: 700;
      font-size: .75rem;
      margin: 0;
      color: #595959;
      line-height: 18px;

    }

  }
  &__body{
    &__list{
      li{
        font-size: .875rem;
        line-height: 1.125rem;
        margin-bottom: 16px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        i{
          font-size: 1.0625rem;
          padding-right: .6875rem;
        }
        span{
          a{
            text-decoration: underline;
            color: #00457f;
          }
        }
      }
    }
  }
  &__footer{
    &__link{
      color: #00457f;
      text-transform: uppercase;
      font-weight: 800;
      font-size: .75rem;
      padding: 5px 13px 4px;
      background-color: #e6e6e6;
      border-radius: 12.5px;
      text-decoration: none;
      transition: all .2s ease;

      &:hover{
        background-color: #00457f;
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>
